import {Component} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("650ms 0s ease"))
        ]),
        trigger("fade-delay", [
            state("void", style({
                opacity: 0.25
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("650ms 650ms ease"))
        ]),
        trigger("slide-down", [
            state("void", style({
                opacity: 0.25,
                transform: "translateY(-100%)"
            })),
            state("true", style({
                opacity: 1,
                transform: "translateY(0)"
            })),
            transition("* => *", animate("650ms ease"))
        ]),
        trigger("slide-in", [
            state("void", style({
                opacity: 0.75,
                transform: "translateX(-100%)"
            })),
            state("true", style({
                opacity: 1,
                transform: "translateX(0)"
            })),
            transition("* => *", animate("650ms ease"))
        ])
    ],
    selector: "fui-nav-layout",
    templateUrl: "./nav-layout.component.html",
    styleUrls: ["./nav-layout.component.scss"],
    standalone: false
})
export class FUINavLayoutComponent {

}
